import isModifiedEvent from './isModifiedEvent.js';

export default function isPrimaryClickEvent(event) {
  return event.button === 0 && !isModifiedEvent(event);
}
